import React, { useState } from "react";
import Button1 from "../../form/Button1";
import TextInput from "../../form/TextInput";
import addVoidMessage from "../../../controllers/booking/postTicketing/void/addVoidMessage";
import { enqueueSnackbar } from "notistack";

export default function AddVoidRemark({ data, close, callback }) {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(ev) {
    ev?.preventDefault();
    if (!message.trim()) {
      enqueueSnackbar("Enter a note before sending.", { variant: "info" });
      return;
    }
    setLoading(true);
    const res = await addVoidMessage(data?._id, {
      message: message.trim(),
    }).finally(() => setLoading(false));
    if (res?.return) {
      setMessage("");
      enqueueSnackbar("Note saved.", { variant: "success" });
      close?.();
      callback?.();
    } else {
      enqueueSnackbar(res?.msg || "Could not save the note. Try again.", {
        variant: "error",
      });
    }
  }

  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm text-gray-600">
        Leave a note for teammates so the next person knows what you already
        checked with the airline or agent.
      </p>
      <TextInput
        label="Remark"
        multiline
        rows={5}
        placeholder="e.g. Airline confirmed this PNR is still inside the void window"
        value={message}
        onChange={(ev) => setMessage(ev.target.value)}
      />
      <div className="flex justify-end items-center gap-4">
        <Button1
          variant="outlined"
          className="btn-outlined flex-1"
          onClick={() => close?.()}
        >
          Cancel
        </Button1>
        <Button1 onClick={(ev) => handleSubmit(ev)} loading={loading}>
          Save note
        </Button1>
      </div>
    </div>
  );
}
